import script from "./lower-pane-details.vue?vue&type=script&setup=true&lang=ts"
export * from "./lower-pane-details.vue?vue&type=script&setup=true&lang=ts"

import "./lower-pane-details.vue?vue&type=style&index=0&id=7f3564a4&lang=css"

const __exports__ = script;

export default __exports__